module.exports = __webpack_public_path__ + "img/renewal.2e06568.png";